import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#diferenciais", label: "Diferenciais" },
  { href: "#processo", label: "Processo" },
  { href: "#cases", label: "Cases" },
  { href: "#depoimentos", label: "Depoimentos" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FAFAFA]/75 border-b border-[rgba(28,28,28,0.08)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center">
          <img
            src="https://customer-assets.emergentagent.com/job_kit-memoria/artifacts/j1su7rjr_MetierCom_Logo150x34.png"
            alt="MetierCom"
            className="h-7 md:h-8 w-auto"
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-[#1C1C1C] link-underline"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="https://mautic.remindbrindes.com.br/metiercomlporc1"
          target="_blank"
          rel="noreferrer"
          data-testid="header-cta-button"
          className="hidden md:inline-flex btn-primary"
          style={{ padding: "12px 24px", fontSize: "0.75rem" }}
        >
          Solicitar Orçamento
        </a>

        <button
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-[#1C1C1C]"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[rgba(28,28,28,0.08)] bg-[#FAFAFA]">
          <nav className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm tracking-wide text-[#1C1C1C]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="https://mautic.remindbrindes.com.br/metiercomlporc1"
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-button"
              className="btn-primary justify-center mt-2"
            >
              Solicitar Orçamento
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
